import React from 'react'

import styles from './logo.module.scss'

const Map = props => {
  const { belowFold } = props
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 185.2 58.1"
      className={`${styles.logo} ${
        belowFold ? styles.logoSmall : styles.logoLarge
      }`}
    >
      <g id="map_1_">
        <path
          d="M31.9,10.8c0,0,0,0.1,0,0.1c0.1,0,0.1,0.1,0.2,0.1c0.2,0,0.4,0.1,0.6,0.1c0.3-0.3,0.5-0.5,0.7-0.9c0,0,0,0,0,0
			c0,0,0-0.1,0-0.1c-0.2,0-0.3,0-0.5,0c-0.2,0-0.4,0.1-0.6,0.1c0,0,0,0.1,0,0.1l0,0c0,0.1,0,0.1,0,0.2
			C32.4,10.6,32.3,10.6,31.9,10.8z"
        />
        <path
          d="M31.5,12.5c0,0.1,0,0.2,0,0.3c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0.5-0.2,0.9-0.3,1.4-0.5
			c0.1-0.1,0.2-0.3,0.3-0.4l0,0c0,0,0-0.1,0.1-0.1c-0.2-0.1-0.4-0.2-0.6-0.3c-0.3,0.1-0.7,0.3-1,0.4C31.7,12.2,31.6,12.3,31.5,12.5z
			"
        />
        <path
          d="M28,10.1c0-0.1-0.1-0.1-0.1-0.2c-0.2,0-0.3-0.1-0.5-0.1c-0.2,0.2-0.4,0.3-0.6,0.5c0,0.2,0.1,0.3,0.1,0.5
			c0.1,0,0.3,0.1,0.4,0.1C27.8,10.6,27.9,10.7,28,10.1z"
        />
        <path
          d="M29.1,9.5c0.3,0,0.7-0.1,1.1-0.1c0.1-0.3,0.2-0.5,0.3-0.8h0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c-0.2-0.2-0.4-0.3-0.6-0.5
			c-0.4,0.3-0.9,0.6-1.3,0.9c-0.1,0.1-0.2,0.3-0.3,0.4c0,0,0.1,0,0.1,0c0,0,0,0,0,0C28.7,9.4,28.9,9.5,29.1,9.5z"
        />
        <path
          d="M33.6,11.5C33.7,11.5,33.7,11.6,33.6,11.5c0.1,0,0.1,0,0.1,0.1c0-0.2,0-0.3,0-0.5c-0.1,0-0.3,0-0.4,0c0,0,0,0,0,0.1
			c0,0,0,0,0,0.1C33.5,11.3,33.5,11.4,33.6,11.5C33.6,11.5,33.6,11.5,33.6,11.5z"
        />
        <path
          d="M39.6,9.7c0.2,0,0.4,0,0.6,0c0.3,0,0.6,0,0.9-0.1c0.3,0,0.6-0.1,1.1-0.1c0,0,0,0,0,0h0h0c0,0,0-0.1,0-0.1
			c-0.7-0.2-1.4-0.3-2.4-0.3c-0.1,0-0.2,0-0.3,0c0,0.2-0.1,0.3-0.1,0.5C39.5,9.7,39.6,9.7,39.6,9.7L39.6,9.7z"
        />
        <path
          d="M34.3,10.6c0,0,0.1,0,0.1,0l0,0c0.1,0.1,0.3,0.1,0.4,0.2c0.1,0,0.3,0.1,0.4,0.1c1.1,0,3.4-0.9,4.1-1.2
			c0-0.2,0.1-0.4,0.1-0.6l0,0c0,0,0-0.1,0-0.1c-2.1,0.2-3.4,0.9-5,1.4C34.3,10.4,34.3,10.5,34.3,10.6z"
        />
        <path
          d="M34.5,11.2C34.5,11.3,34.5,11.3,34.5,11.2c0.1,0,0.1,0,0.1,0c0-0.1,0-0.1,0-0.2c-0.1,0-0.3-0.1-0.4-0.1c0,0,0,0,0,0
			c0,0,0,0.1,0.1,0.1C34.3,11.2,34.3,11.2,34.5,11.2z"
        />
        <path
          d="M30.4,11.9c0.2,0,0.4-0.1,0.6-0.1c0.1-0.2,0.2-0.4,0.3-0.6c0,0,0,0,0-0.1c0,0,0,0,0-0.1c-0.1,0-0.1,0-0.2,0
			c-0.3,0.2-0.5,0.3-0.8,0.5c0,0.1-0.1,0.2-0.1,0.3C30.3,11.9,30.3,11.9,30.4,11.9C30.4,11.9,30.4,11.9,30.4,11.9z"
        />
        <path
          d="M35.2,8.7c0,0.1,0,0.1,0,0.2c0,0,0,0,0,0c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0.8-0.2,1.6-0.5,2.7-0.6
			c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1c-0.2,0-0.3,0-0.5,0c-0.6,0-0.9-0.2-1.5-0.4C35.8,8.1,35.5,8.4,35.2,8.7z"
        />
        <path
          d="M45.1,12.8c0,0-0.1-0.1-0.1-0.1c0.1-0.4,0.1-0.4,0.2-0.6c0,0,0,0,0-0.1c0,0,0,0,0-0.1c-0.4,0-0.9-0.1-1.3-0.1
			c-0.5,0.2-0.9,0.3-1.3,0.3c-0.3,0-0.6,0-0.9-0.1c-0.3,0-0.5-0.1-0.8-0.1c-0.2,0-0.4,0-0.5,0.1c-0.4,0.3-0.8,0.6-1.1,0.9
			c-0.2,0-0.4,0.1-0.6,0.1c-0.2,0-0.5,0-0.7,0c-0.2,0-0.5,0-0.7,0c-0.4,0-0.9,0.1-1.3,0.3c-1.4,0.9-3.1,1.5-4.6,2.4
			c-1.1,0.7-2.1,1.4-3.2,2.1c-0.1,0.2-0.1,0.5-0.2,0.7c0.1,0.1,0.2,0.3,0.3,0.4c1.5-0.4,2.5-2,3.8-2.8c0.5-0.3,1-0.1,1.7-0.3
			c0.8-0.3,2.1-1.2,2.8-1.5c0.7,0,1.4,0,2.2,0c0.4-0.3,0.8-0.6,1.2-0.9c0.2-0.1,0.6-0.1,0.9-0.1c1,0,2.1,0.3,2.6,0.4
			c0.6-0.2,1.3-0.3,1.9-0.5c2.5,0.5,5.5,0.6,8.3,1l0,0c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1c-1.2-1.4-6.4-1.6-8-1.9
			c-0.2,0.2-0.4,0.3-0.6,0.5C45.3,12.7,45.2,12.8,45.1,12.8z"
        />
        <path
          d="M40.6,10.7c-0.3,0-0.6,0-0.9,0c-0.5,0-1,0-1.5,0.2c-1.2,0.4-2.3,0.8-3.5,1.1c0,0.1,0,0.2,0,0.2c0,0.1,0,0.1,0.1,0.3
			c-2.2,0.6-5.1,2.1-6.8,3.6c0,0.1,0,0.2,0,0.3c0,0,0,0,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0.1,0c0,0,0,0,0.1,0c4-2,9.5-5.2,14.9-5.2
			c0.8,0,1.6,0.1,2.4,0.2c0,0,0.1,0,0.1,0c0,0,0,0,0,0c-0.6-0.7-1.5-1-2.8-1c-0.1,0-0.2,0-0.3,0c-0.3,0.2-0.6,0.3-1.1,0.3
			C41.2,10.7,40.9,10.7,40.6,10.7z"
        />
        <path
          d="M35.4,8.1C35.4,8.1,35.4,8.1,35.4,8.1C35.5,8,35.5,8,35.5,8c-0.2,0-0.4-0.1-0.6-0.1c-0.6,0.8-2,0.8-3.2,1
			c-0.2,0.2-0.2,0.3-0.2,0.7c-0.1,0-0.1,0-0.2,0c-1.9,0-2.6,1.5-3.9,2.3c-2.1,1.2-9.6,9.3-9.8,12c0.1,0,0.1,0.1,0.2,0.1
			c1.7-1.2,1.9-3.6,3.3-5.1c3.6-3.8,8-8.5,13.2-9.6C34.7,8.9,35.1,8.5,35.4,8.1z"
        />
        <path d="M26.8,10.9c-0.1-0.2,0-0.1-0.2-0.2l0,0C26.6,10.7,26.7,10.8,26.8,10.9L26.8,10.9z" />
        <path
          d="M48.9,16.6C48.9,16.6,48.9,16.6,48.9,16.6c0.1,0,0.1,0,0.1,0c0-0.1-0.1-0.2-0.1-0.3c-0.4-0.3-0.7-0.4-1.4-0.4
			c0,0-0.1,0-0.1,0c0,0.1,0,0.2,0,0.3c0.2,0.2,0.4,0.3,0.6,0.5C48.3,16.7,48.6,16.7,48.9,16.6C48.9,16.6,48.9,16.6,48.9,16.6z"
        />
        <path
          d="M21.5,17.1c0.8-1.5,1.7-2.5,3.1-3.4c-0.1-0.4,0-0.2-0.2-0.4c-3,2.3-5.2,4.9-7,8.5c-0.1,0.1-0.2,0.2-0.3,0.3
			c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0c1.2-0.9,1.4-2.1,2.3-3.4C20.2,18.3,20.9,17.7,21.5,17.1z"
        />
        <path
          d="M22.1,19.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1c0.1-0.1,0.2-0.2,0.3-0.3c0,0,0.1-0.1,0.1-0.1
			c0,0,0,0,0,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0.1-0.2,0.1C22.1,19,22.1,19,22.1,19.1z"
        />
        <path
          d="M28.3,13.2C28.3,13.2,28.4,13.2,28.3,13.2c0.1,0,0.1-0.1,0.1-0.1c0.4-0.3,0.8-0.5,1.1-1c0,0,0,0,0,0c0,0,0-0.1,0-0.1
			c-0.1,0-0.1,0-0.2,0c-0.3,0.1-0.6,0.3-0.9,0.4C28.4,12.7,28.4,13,28.3,13.2z"
        />
        <path
          d="M23.3,17.5C23.3,17.5,23.4,17.5,23.3,17.5c0.2,0,0.2,0,0.3-0.1c0-0.1,0-0.1,0-0.2c-0.1,0-0.2,0-0.3,0
			c0,0.1-0.1,0.1-0.1,0.2C23.2,17.5,23.3,17.5,23.3,17.5z"
        />
        <path
          d="M53.6,14.9C53.6,14.9,53.6,14.9,53.6,14.9c0.3,0.6,1.9,1.3,2.7,1.5c0,0,0.1,0,0.1,0c0-0.1,0.1-0.1,0.1-0.2
			c-0.5-0.4-1.1-0.8-1.6-1.2C54.4,14.8,54,14.8,53.6,14.9C53.6,14.8,53.6,14.8,53.6,14.9z"
        />
        <path
          d="M11.6,16.7c-0.1,0.2-0.2,0.5-0.3,0.7c0,0.1,0,0.1,0,0.2v0c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0l0,0c0.1,0,0.3-0.1,0.4-0.1
			c0.1-0.2,0.1-0.3,0.2-0.5C11.9,17,11.7,16.9,11.6,16.7z"
        />
        <path
          d="M13.1,11.8c0.1,0,0.1-0.1,0.2-0.1c0-0.2,0.1-0.5,0.1-0.7c0-0.2,0-0.4-0.2-0.6c-0.4,0.3-0.6,0.7-1,1c0,0.1,0.1,0.3,0.1,0.4
			C12.6,11.8,12.9,11.8,13.1,11.8z"
        />
        <path
          d="M13.1,14.2L13.1,14.2c-0.4,0.5-1.2,1.3-1.3,2.4c0,0,0.1,0,0.1,0c0,0,0,0,0,0c1-0.2,1-1.1,2-1.4c0,0,0-0.1,0-0.1
			c0-0.1,0-0.2,0-0.2C14,14.3,13.9,14.2,13.1,14.2z"
        />
        <path
          d="M12,19.3C12,19.3,12,19.3,12,19.3c0.1,0,0.1,0,0.1,0.1c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0-0.2,0-0.2,0-0.3
			c0-0.1-0.1-0.1-0.3-0.3c-0.1,0.1-0.1,0.1-0.2,0.2C11.8,19,11.8,19.2,12,19.3C11.9,19.3,12,19.3,12,19.3z"
        />
        <path
          d="M24.3,5.7c0.7-0.2,1.4-0.4,2.1-0.6l0,0l0,0c0,0,0-0.1,0-0.1c-0.4,0-0.8-0.1-1.1-0.1C25.2,5,25,5.1,24.8,5.1
			c-0.1,0-0.1,0-0.2,0c-0.1,0.2-0.3,0.3-0.4,0.5v0c0,0,0,0.1,0,0.1C24.2,5.7,24.3,5.7,24.3,5.7L24.3,5.7z"
        />
        <path
          d="M13.2,8.4C13.2,8.4,13.2,8.3,13.2,8.4c0-0.1-0.1-0.1-0.2-0.1c-0.7,1-1.4,2.1-2.2,3.1c0,0,0,0.1,0,0.1c0.1,0,0.3,0,0.4,0
			C12.1,10.8,12.9,9.6,13.2,8.4L13.2,8.4z"
        />
        <path
          d="M15.8,12.4c1.5-2,2.8-3.5,4.2-5.3c0.4-0.5,1.1-0.5,1.4-1.1c0.2-0.2,0.3-0.3,0.3-0.5c0-0.1-0.1-0.3-0.2-0.5
			c-1.1,1.4-2.1,1.4-3.3,2.5c-0.9,0.8-1.1,2.3-1.7,3.3c-0.7,1.1-2.1,1.2-2.8,2.6c0.1,0.2,0.3,0.3,0.5,0.3
			C14.8,13.6,15.6,12.7,15.8,12.4z"
        />
        <path d="M14,7.7c-0.1-0.2,0-0.1-0.2-0.2l0,0C13.8,7.6,13.9,7.6,14,7.7L14,7.7z" />
        <path
          d="M21.9,1.9C21.9,1.9,21.9,1.9,21.9,1.9c-1.4,0.2-3.6,1.8-4.1,3C17.6,5,17.3,5,17,5c0,0.2,0,0.4,0,0.6
			c-1.4,1.4-2.8,2.2-3.7,4.2c0.3,0.3,0.4,0.2,0.7,0.3c0.5-0.4,2.6-3.3,2.6-3.7c0,0,0,0,0,0c0.6-0.5,1.7-0.7,2.5-1.3
			c0.9-0.7,1.1-1.4,2.4-1.8C21.6,2.8,21.8,2.4,21.9,1.9C21.9,2,21.9,1.9,21.9,1.9z"
        />
        <path
          d="M18.6,6.7c1.1-0.8,2.1-1,2.8-2.2c0-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1,0-0.1C21.3,4,21.3,4,21.1,3.9c-2.6,2.3-5,4.2-6.9,7.2
			c0,0,0,0.1,0,0.1c0.1,0,0.1,0.1,0.2,0.1C16.3,10.3,17.1,7.7,18.6,6.7z"
        />
        <path
          d="M30.8,6c-0.4,0-0.8,0-1.2,0c-0.1,0.3-0.3,0.5-0.4,0.8c-0.4,0.4-3,1.3-3,1.3c-0.9,0.8-2,2.4-2.8,3.3c0,0,0,0,0.1,0
			c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c1.7,0,3.4-3,4.8-3.6c2-0.9,4.8-2.1,7.3-2.9c0-0.1,0.1-0.1,0.1-0.2c-0.2-0.3-0.4-0.6-0.6-0.9
			C34.1,4.7,32.2,5.5,30.8,6z"
        />
        <path
          d="M23.8,8.9L23.8,8.9c0,0,0.1,0,0.1-0.1c-0.2-0.4-0.1-0.3-0.6-0.4c-0.6,0.5-1.3,1-1.9,1.5c0,0.1,0.1,0.1,0.1,0.2
			c0.2,0,0.3,0.1,0.5,0.1C22.5,9.8,23.1,9.4,23.8,8.9C23.7,8.9,23.8,8.9,23.8,8.9z"
        />
        <path
          d="M21.1,10.6C21.1,10.6,21.1,10.6,21.1,10.6c-0.1-0.1-0.2-0.1-0.3-0.1c-0.7,0.6-1.7,0.8-2.1,1.7c-0.1,0.1-0.1,0.3-0.2,0.4
			c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1c0.7-0.3,1.3-0.6,2-0.9C20.8,11.4,21,11,21.1,10.6C21.1,10.7,21.1,10.7,21.1,10.6z"
        />
        <path
          d="M19.2,14.4c0,0,0.1,0,0.1,0h0c1.4-0.3,2.6-1.9,3-3.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1c-0.1,0-0.1,0-0.2,0
			c-1,0.9-2.1,1.7-3.1,2.6c0,0.2,0.1,0.4,0.1,0.6v0C19.2,14.3,19.2,14.3,19.2,14.4z"
        />
        <path
          d="M31.3,8.1C31.3,8.1,31.3,8.1,31.3,8.1L31.3,8.1c0.1,0,0.1,0,0.1,0C32.9,8.1,37,7,37,5.6c0-0.1,0-0.1,0-0.2
			c-0.2,0-0.4-0.1-0.6-0.1c-1.4,1.2-3.6,1.5-4.9,2.5C31.4,7.9,31.3,8,31.3,8.1z"
        />
        <path
          d="M32.8,3.9c0.8-0.2,1.6-0.4,2.4-0.6l0,0c0,0,0.1,0,0.1,0c0-0.1-0.1-0.2-0.1-0.3c-0.3-0.4-1.1-0.3-1.6-0.4
			c-0.4,0.4-0.8,0.6-0.9,1.3C32.7,3.9,32.7,3.9,32.8,3.9C32.7,3.9,32.7,3.9,32.8,3.9z"
        />
        <path
          d="M22.9,10.6c0.1,0,0.1,0,0.2,0c0.5-0.3,1-0.6,1.3-1.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1c-0.1,0-0.1,0-0.2,0
			c-0.4,0.3-0.9,0.6-1.3,0.9c0,0.1-0.1,0.2-0.1,0.3C22.8,10.6,22.8,10.6,22.9,10.6C22.9,10.6,22.9,10.6,22.9,10.6z"
        />
        <path
          d="M23.8,8.3c0.1,0,0.2,0.1,0.3,0.1c1.9-1,3.2-2.2,4.8-3.2c0.6-0.3,1.2,0,1.6-0.5c0.1-0.1,0.2-0.2,0.3-0.3
			c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c-0.5,0-1,0-1.5,0C28.1,5.2,24.2,6.8,23.8,8.3z"
        />
        <path
          d="M27.1,4.3c0.2,0,0.4,0,0.6,0C28,4.1,28,4.1,28,3.9c0,0,0,0,0-0.1c0,0,0,0,0-0.1c-0.3,0.1-0.6,0.2-0.9,0.3
			c0,0.1-0.1,0.1-0.1,0.2C27,4.3,27,4.3,27.1,4.3C27.1,4.3,27.1,4.3,27.1,4.3z"
        />
        <path
          d="M33.8,2.1c0.3-0.1,0.6-0.1,0.9-0.2c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.1,0-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.2,0-0.3,0
			c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.2-0.3,0.4-0.5,0.6c0,0,0,0,0,0C33.7,2.1,33.8,2.1,33.8,2.1z"
        />
        <path
          d="M26,40.1c0.1,0.1,0.2,0.1,0.3,0.2c0,0,0-0.1,0.1-0.1l0,0c0.1-0.2,0.2-0.4,0.2-0.6c0-0.2-0.1-0.5-0.3-0.9
			c-0.2-0.2,0-0.1-0.3-0.2c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0.4,0,0.2,0.2,0.5c-0.1,0.1-0.3,0.1-0.4,0.2
			C25.8,39.6,25.9,39.8,26,40.1z"
        />
        <path
          d="M14.5,6.9C14.5,6.9,14.5,6.9,14.5,6.9c0-0.1,0-0.1,0-0.1c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0.1-0.2,0.1
			c0,0.1-0.1,0.2-0.1,0.3v0c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0c0,0,0,0,0,0C14.5,7.2,14.4,7.2,14.5,6.9z"
        />
        <path
          d="M22.9,22.2c0,0,0,0.1,0,0.1c0.1,0,0.1,0.1,0.2,0.1c0.6-0.8,1.2-1.7,1.5-2.8c0,0,0,0,0,0c0,0,0-0.1,0-0.1
			c-0.1,0-0.2,0-0.3,0C23.6,20.1,23.1,21.1,22.9,22.2z"
        />
        <path
          d="M30.1,43.6c-0.1,0.2-0.1,0.4-0.1,0.6c0,1.2,1.5,2.3,2.1,3c0.1,0,0.3,0,0.4,0c0-0.1,0.1-0.1,0.1-0.2
			C32.2,46.5,30.5,43.8,30.1,43.6z"
        />
        <path
          d="M39.4,43.6C39.4,43.6,39.4,43.6,39.4,43.6c0.1,0.3,0.1,0.2,0.2,0.4c0.2,0,0.3-0.1,0.5-0.1c0,0,0,0,0.1,0c0,0,0,0,0.1,0
			C40,43.6,39.9,43.6,39.4,43.6C39.4,43.5,39.4,43.6,39.4,43.6z"
        />
        <path
          d="M26.3,41.1c0,0.3,0.1,0.6,0.1,0.8c0,0.1,0.1,0.3,0.1,0.4c0.1,0,0.1,0,0.2,0c0.1-0.1,0.1-0.2,0.1-0.4
			c0-0.4-0.2-0.8-0.5-1.1c0,0,0,0,0,0.1C26.3,41,26.3,41.1,26.3,41.1z"
        />
        <path
          d="M24,22.8C24,22.8,24,22.8,24,22.8c-0.1-0.1-0.2-0.1-0.4-0.1c-0.9,0.9-1,1.4-1.3,2.8c0.1,0.1,0.1,0.1,0.2,0.2
			C23.4,25,23.5,23.7,24,22.8C24,22.9,24,22.9,24,22.8z"
        />
        <path
          d="M22.3,29.8L22.3,29.8L22.3,29.8c0.3-0.4,0.6-0.8,0.8-1.2c-0.1-0.5-0.3-1-0.4-1.5c-0.1,0-0.2-0.1-0.3-0.1
			c-0.2,0.5-0.2,0.9-0.2,1.4c0,0.4,0,0.8,0,1.3c0,0.1,0,0.1,0,0.2C22.2,29.8,22.2,29.8,22.3,29.8z"
        />
        <path
          d="M26.9,39.5C26.9,39.5,27,39.5,26.9,39.5c0.2,0.1,0.2,0.1,0.3,0.2c0,0,0,0,0,0c0,0,0,0,0.1,0.1c0,0,0,0,0-0.1
			c0,0,0,0,0-0.1c0.1-0.3,0.2-0.5,0.5-0.7c-0.8-2-1.3-5.9-1.3-8.9c0-1.2,0.1-2.2,0.3-2.9c-0.2-0.3-0.1-0.3-0.6-0.4
			c-0.2,1.2-0.5,2.8-0.5,4.4c0,1,0.1,2,0.4,2.9c-0.2,0.1-0.4,0.3-0.6,0.4c0.3,0.8,1.4,3.7,1.4,4.7c0,0.1,0,0.1,0,0.2
			C26.8,39.5,26.8,39.5,26.9,39.5L26.9,39.5z"
        />
        <path
          d="M39.2,41.5c0.1,0,0.3,0.1,0.4,0.1l0,0l0,0c0,0,0.1,0,0.1,0c0-0.2,0-0.3,0-0.5c-0.2-0.1-0.5-0.2-0.7-0.3
			c-0.1,0.2-0.1,0.2-0.1,0.2l0,0l0,0c0,0-0.1,0-0.2,0.1c0,0,0,0,0.1,0.1l0,0C38.9,41.2,39.1,41.3,39.2,41.5z"
        />
        <path
          d="M32.4,47.7c0,0.5,0.7,1.1,1,1.5c0.2,0,0.4-0.1,0.6-0.1c0-0.1,0.1-0.1,0.1-0.2c-0.6-0.5-0.6-1.3-1.6-1.4
			C32.4,47.5,32.4,47.6,32.4,47.7z"
        />
        <path
          d="M55.4,18.3c0.4,0.2,1,0.4,1.4,0.5c0.1,0,0.1-0.1,0.2-0.1c0-0.1,0.1-0.1,0.1-0.2c-0.5-0.2-0.8-0.4-1.6-0.4c0,0-0.1,0-0.1,0
			C55.5,18.1,55.4,18.2,55.4,18.3z"
        />
        <path
          d="M51.2,17.8c0.2,0,0.5,0,0.7,0.1c0.1-0.5,0.1-0.5,0.4-0.7c0,0,0.1,0,0.1,0c0,0,0,0,0,0c-0.4-0.1-0.8-0.3-1.1-0.4
			c-0.9,0.7-1.8,0.3-2.7,0.8c0.2,1.1,1,1,1.4,1.8c0.4,0,0.8-0.4,1.3-0.4c0.1,0,0.3,0,0.4,0.1c0-0.1,0.1-0.1,0.1-0.2
			c-0.5-0.3-1-0.5-1.4-0.8c0,0,0-0.1,0-0.1C50.8,17.8,51,17.8,51.2,17.8z"
        />
        <path
          d="M52.9,17.3L52.9,17.3c0,0.1,0.1,0.2,0.1,0.3c0.6,0.1,1.2,0.3,1.7,0.4c0.1,0,0.2,0,0.3,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0
			c-0.5-0.5-1.1-0.8-2.1-0.8C53,17.2,52.9,17.2,52.9,17.3C52.8,17.3,52.9,17.3,52.9,17.3z"
        />
        <path
          d="M48.1,14.6c-0.1,0.1-0.2,0.1-0.3,0.2c0,0,0,0,0.1,0c0,0,0,0,0,0c0.6,0.4,1.5,0.4,2.4,0.6c2.8,1,5.7,2,8.8,2.9
			c0.4-0.1,0.5-0.1,0.5-0.2c0-0.1,0-0.2-0.1-0.4c-0.7-0.3-1.4-0.5-2.1-0.8c-0.1,0.2-0.2,0.4-0.3,0.6c-1.9-1.4-5.5-3-8.6-3.2
			C48.4,14.4,48.3,14.5,48.1,14.6z"
        />
        <path
          d="M44.1,17.1c1.5,0,3.1,0.4,3.8,0.7c0.1,0,0.2,0,0.3,0c0,0,0,0,0.1,0c0,0,0,0,0.1,0c-0.4-0.8-1-1.6-1.9-1.9
			c-0.2,0.2-0.3,0.4-0.5,0.6c-0.7-0.1-1.4-0.3-2.1-0.4c-0.8,0.4-1.8,0-2.8,0.4c-0.6,0.4-1.2,0.8-1.8,1.2c-1.6,0.7-2.9,0.5-4,1.3
			c-0.7,0.5-0.8,1.4-1.4,2.1c-0.6,0.6-1.8,0.2-2.3,0.9c-0.6,0.9-0.3,2-0.7,3.1c-0.5,1.3-1.4,2.2-1.8,3.6v0c0,0,0,0,0,0.1
			c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0.2-0.1,0.3-0.2,0.5-0.2c0,0.6-0.1,1.3-0.1,1.9c0.3,1.6,0.9,2.3,0.9,4.1c0,0.1,0,0.2,0,0.3
			c0.3,0,0.6,0.1,0.9,0.1c-0.1,0.2-0.1,0.4-0.1,0.6c0,0.7,0.4,1.6,0.8,2.4c0.5,0.8,2.5,3.3,4,3.9l0,0l0,0c0,0,0.1,0,0.1,0
			c0-0.1,0-0.2,0-0.3c-0.5-0.9-1.4-1.3-1.9-2.1c-1-1.4-3.9-6.4-3.9-9.9c0-0.9,0.2-1.7,0.6-2.3c0.1-0.1,0.2-0.2,0.2-0.2
			c0.1,0,0.1,0,0.3,0.1c0.2-0.8-0.1-0.7,0.3-1.3c-0.2-0.2-0.3-0.3-0.5-0.5c0.9-1,1-2.1,1.7-3.3c0.1-0.2,0.3-0.4,0.5-0.6
			c0.2-0.2,0.5-0.4,0.7-0.6c1.3-1,3.3-1.8,4.6-2.4c0.1,0,0.1,0,0.1,0c0.2,0,0.4,0.2,1,0.2c0.1-0.2,0.2-0.4,0.3-0.6
			c0.2,0,0.5,0,0.8,0c0.2,0,0.4,0,0.7,0c0.1,0,0.1,0,0.2,0c0.4,0,0.9,0.1,1.4,0.1c0.8,0.1,1.6,0.1,2.4,0.1c0.3,0,0.6,0,0.9,0
			c0,0,0-0.1,0-0.1c-0.6-0.3-1.5-0.4-2.5-0.4c-0.9,0-1.7,0.1-2.4,0.2c0,0,0-0.1,0-0.1C42,17.3,43,17.1,44.1,17.1z"
        />
        <path
          d="M33.2,31.1c-0.2,0.2-0.3,0.6-0.3,1c0,1.1,0.6,2.5,1.3,3h0c0,0,0.1,0,0.1,0.1c0.1-0.2,0.2-0.3,0.3-0.5c0,0,0,0,0-0.1
			c0-0.7-1.2-4.4-1.3-5.5c0-0.1,0-0.1,0-0.2c0-0.3-0.3-0.4-0.6-0.5c0,0,0,0.1,0,0.1c0,0.5-0.1,1.1-0.1,1.6
			C32.6,30.5,32.7,30.9,33.2,31.1z"
        />
        <path
          d="M32.1,28.3c0,0,0-0.1,0-0.1c-0.2,0-0.5-0.1-0.7-0.1c0,0.5-0.5,1.8-0.5,1.8c0,2.9,2.2,6.1,3.3,8.6c0.3,0.3,0.6,0.5,0.9,0.8
			c0.2-0.1,0.4-0.2,0.6-0.3c0-0.1,0.1-0.1,0.1-0.2c-0.9-1.7-2.4-2.8-2.8-4.9c-0.2,0-0.5-0.1-0.7-0.1c0.1-0.3,0.2-0.6,0.2-0.9
			c0-1-0.4-2.1-0.7-3C31.9,29.4,32,28.9,32.1,28.3L32.1,28.3z"
        />
        <path
          d="M51.3,19.3C51.3,19.4,51.3,19.4,51.3,19.3c0,0.2,0,0.2,0.1,0.3c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0
			c0,0,0,0,0.1-0.1c0,0,0.1-0.1,0.1-0.1l0,0c0,0,0,0,0.1-0.1C51.6,19.4,51.4,19.4,51.3,19.3C51.3,19.3,51.3,19.3,51.3,19.3z"
        />
        <path
          d="M35.7,39.2c0,0.1,0,0.2,0,0.2c0,2.2,2.4,3.3,3.7,3.9c0,0,0.1-0.1,0.1-0.1l0,0c0,0,0.1-0.1,0.1-0.1
			C38.5,42,37.4,39.5,35.7,39.2z"
        />
        <path
          d="M46.6,14.5C46.6,14.5,46.7,14.5,46.6,14.5c-0.5-0.4-1.5-0.4-2.4-0.4c-0.4,0-0.9,0-1.3,0c-0.4,0-0.8,0-1.1,0
			c0,0-0.1,0-0.1,0c-2.1,0.9-4,0.4-6.2,1.4c-1.2,0.6-1.4,2-2.1,2.8l-2.8,2.5c-0.2,0-0.3-0.1-0.5-0.1c-0.1,0.4-0.3,0.9-0.4,1.3
			c-1.3,1.6-1.6,3.4-2.6,5.5c0.1,0.2,0.2,0.6,0.2,1c0,0.3,0,0.7-0.1,0.9c0,0.2,0,0.4,0,0.6c0,0.4,0.1,0.5,0.5,0.5c0.1,0,0.2,0,0.3,0
			c0.1-1.2,0.1-2.3,0.2-3.5c0.3-0.7,1-1.4,1-2.5c0.3-0.1,0.5-0.1,0.8-0.2c0.4-2.7,4.3-7.3,6.9-8.5c1-0.5,2.3-0.4,3.7-0.5l0,0
			c0,0,0.1,0,0.1,0c0-0.2,0-0.3,0-0.4c0-0.2,0.1-0.3,0.2-0.4c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0.1,0.1,0.1,0.2,0.1,0.2
			c0,0-0.1,0.1-0.1,0.3c0.2,0.2,1.6,0.3,2.9,0.3c1.2,0,2.3-0.1,2.6-0.2c0.1,0,0.1,0,0.2,0c0,0,0-0.1,0-0.1c0,0,0,0,0,0
			c0,0,0-0.1,0-0.1c-0.2,0-0.4-0.1-0.6-0.1C46.4,14.7,46.5,14.6,46.6,14.5L46.6,14.5z"
        />
        <path d="M30.6,49c0,0.2-0.1,0.4-0.1,0.6c0,0,0,0,0,0c0,0,0.1,0,0.1-0.1c0.1,0,0.1-0.1,0.2-0.1C30.7,49.3,30.6,49.2,30.6,49z" />
        <path
          d="M29,44.8c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.3-0.1l0,0c0,0,0.1,0,0.1,0c-0.4-0.8-1.3-4.6-1.8-4.9
			c-0.2,0.2-0.4,0.5-0.6,0.7c0.3,0.5,0.1,1,0.4,1.7C28.1,43.2,28.6,44,29,44.8z"
        />
        <path
          d="M30.6,52.3c0-0.1,0.1-0.1,0.1-0.2c-0.4-0.4-0.8-1.3-1.3-1.6c-0.2,0.1-0.3,0.2-0.5,0.3c0.3,0.5,0.5,1,0.8,1.5
			C30,52.3,30.3,52.3,30.6,52.3z"
        />
        <path d="M30.2,47.2c0.3,0,0.6,0,0.9,0c0,0,0-0.1,0-0.1c-0.4-0.5-0.8-1-1.4-1.2c0,0.1,0,0.2,0,0.2C29.6,46.6,29.9,46.8,30.2,47.2z" />
        <path
          d="M31.9,48.4c0-0.1,0.1-0.1,0.1-0.2c-0.3-0.3-0.6-0.5-0.9-0.8c-0.1,0.2-0.3,0.3-0.4,0.5c0.3,0.3,0.6,0.5,1.1,0.5
			C31.8,48.4,31.9,48.4,31.9,48.4z"
        />
        <path
          d="M35.9,45.4c0.1,0.1,0.3,0.3,0.4,0.4l0,0l0,0c0,0,0.1,0,0.1,0c-0.2-1.2-1.8-2.8-2.8-3.3c0-0.2,0.1-0.3,0.1-0.5
			c0-0.1,0-0.1,0-0.2c0.6,0.3,0.7,1,1.4,1.3c0,0,0.1,0,0.1,0c0,0,0,0,0,0c-0.4-1-1-2.2-2.1-2.6c0,0,0,0,0,0.1c0,0,0,0,0,0.1
			c0,0.1,0.1,0.3,0.1,0.4c-1.1-0.9-2.9-5.8-3.8-6.1c0,0.4-0.1,0.9-0.1,1.3c0.2,0.2,0.4,0.3,0.6,0.5c0,0.4,0.1,0.8,0.1,1.2
			c0.5,1.3,2,2.2,2.6,3.4C33.7,43.5,33.9,44.4,35.9,45.4z"
        />
        <path
          d="M24.3,22L24.3,22c0.1,0.1,0.1,0.1,0.2,0.1c0,0,0.1,0,0.1,0c0.1-0.2,0.1-0.4,0.2-0.6c-0.1,0-0.1-0.1-0.2-0.1
			C24.5,21.6,24.4,21.8,24.3,22C24.2,22,24.3,22,24.3,22z"
        />
        <path
          d="M32.2,42.4c-0.2-0.8-0.9-2-1.5-2.4c0,0.1,0,0.2,0,0.3c0,0.8,0.5,1.7,0.9,2.3c0.1,0,0.2-0.1,0.3-0.1
			C32,42.4,32.1,42.4,32.2,42.4z"
        />
        <path
          d="M33.1,45.7C33.1,45.7,33.2,45.7,33.1,45.7c0.1,0,0.1,0,0.1,0c-0.7-1.5-1.8-2.6-2.9-3.7c-0.6-0.6-0.8-2.9-0.9-3.3
			c-0.6-1.4-0.2-3.7-1.4-4.3c-0.2,0.6-0.2,1.2-0.2,1.8c0,3.9,3.1,7.6,4.5,9.6c0.6,0,0.5-0.1,0.6-0.1C33,45.7,33,45.7,33.1,45.7z"
        />
        <path
          d="M34.2,45.6C34.2,45.6,34.3,45.7,34.2,45.6c-0.1-0.4-0.2-0.4-0.6-0.6c0.1-0.1,0.2-0.3,0.3-0.4c-0.4-0.5-0.7-0.8-0.7-1.2
			c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c-0.2,0-0.3,0.1-0.5,0.1c-0.1-0.2-0.2-0.5-0.3-0.7c-0.2,0.4,0,0.2-0.4,0.3
			c0.2,1.2,1.2,2.1,2.1,2.7C34.1,45.6,34.2,45.6,34.2,45.6z"
        />
        <path
          d="M26.7,26.6c0.4-0.7,2.5-4.7,2.8-5.7c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0,0,0,0c-1.7,1.4-2.5,3.4-3.3,5.6
			C26.3,26.4,26.5,26.5,26.7,26.6z"
        />
        <path
          d="M28,17c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0,0,0.1-0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.5,0.2-1,0.3-1.3,0.6
			c-0.2,0.4-0.4,0.8-0.6,1.1c0,0.1,0.1,0.1,0.1,0.2c0.1,0,0.2,0.1,0.3,0.1C26.9,18.2,27.5,17.6,28,17z"
        />
        <path
          d="M27.3,22.3c0.9-0.5,0.8-1.6,1.6-2.1c0.6-0.4,1.2-0.2,1.7-0.5c1.1-0.7,2.3-2,3-3.2c0,0,0,0,0,0c0,0,0,0,0-0.1
			c-0.2,0-0.5-0.1-0.7-0.1c0,0.2-0.1,0.4-0.1,0.6c-2.5,0.7-3.8,2.8-5.6,4.2c0,0.4-0.1,0.8-0.1,1.2C27.2,22.4,27.2,22.3,27.3,22.3
			C27.3,22.3,27.3,22.3,27.3,22.3z"
        />
        <path
          d="M24.6,24.5c0.6-1.3,2.4-4.5,3.5-5.2c0-0.1,0-0.1,0.1-0.2l0,0c0,0,0-0.1,0-0.1c-0.2,0-0.4-0.1-0.6-0.1
			c-1.2,0.9-1,1.7-1.7,3.1c-0.3,0.6-1.2,1.1-1.5,1.6c-0.7,1.3-0.2,2.6-1.1,3.3c0.1,0.2,0.1,0.4,0.2,0.6
			C24.4,27.3,24.2,25.4,24.6,24.5z"
        />
        <path
          d="M24.9,20.9C25,20.9,25,20.9,24.9,20.9l0.1,0c0.2-0.1,0.3-0.1,0.5-0.2c0.1-0.5,0.2-1.1,0.3-1.6c-0.1,0-0.1-0.1-0.2-0.1
			c-0.1,0-0.1,0.1-0.2,0.1c-0.3,0.5-0.5,0.9-0.5,1.5c0,0.1,0,0.2,0,0.3L24.9,20.9C24.9,20.9,24.9,20.9,24.9,20.9z"
        />
        <path
          d="M29.4,34.1c0.1-0.1,0.1-0.1,0.2-0.2c0-0.6-0.1-1.2-0.1-1.8c-0.3-0.3-0.3-0.4-0.7-0.5c-0.1,0.3-0.1,0.5-0.1,0.8
			c0,0.6,0.1,1.1,0.2,1.7C29.1,34,29.3,34,29.4,34.1z"
        />
        <path
          d="M38.8,45.6c0.2-0.2,0.2-0.2,0.4-0.3l0,0c0,0,0.1,0,0.1,0c-0.2-0.4-0.3-0.3-0.3-0.9c-1.5-0.1-1.6-1.1-2.5-1.8
			c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3,0.1-0.5,0.1c0,0,0,0.1,0,0.1l0,0C36.1,44.2,37.6,44.9,38.8,45.6z"
        />
        <path
          d="M27.4,31.6c0,0.1,0,0.2,0,0.2c0,0.6,0.3,1.4,0.6,2.3c0.1,0,0.1,0,0.2,0h0c0,0,0.1,0,0.1,0c-0.1-0.8,0-2.3-0.5-2.8
			C27.7,31.5,27.5,31.5,27.4,31.6z"
        />
        <path
          d="M38.7,16.1c-0.2,0-0.3,0-0.5,0c-0.1,0-0.1,0-0.2,0c-1.2,0.1-2.7,1.8-3.3,2.6c0,0,0,0,0,0c0.1,0,0.1,0,0.2-0.1
			c1.8-0.6,3.1-2.3,5.4-2.4c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1c0,0,0,0,0-0.1c-0.2,0-0.4,0-0.6,0c-0.3,0.1-0.5,0.2-0.7,0.2
			C39,16.2,38.9,16.2,38.7,16.1z"
        />
        <path
          d="M44.9,42.8c-0.5-0.2-1.1-0.5-1.6-0.7c-0.4-0.4-0.8-1.3-1.2-1.5c-0.5-0.2-1.1-0.3-1.6-0.5c-0.9-0.6-1.8-1.6-2.7-2.2
			c-0.2,0.2-0.3,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.9-0.2c0.1-0.3-0.1-0.2,0.2-0.4l0,0c0,0,0.1,0,0.1-0.1c-0.5-0.7-1-1.4-1.4-2.2
			c-0.2,0.1-0.4,0.3-0.6,0.4c0.3,1.4,1.8,3.5,3,4.1c0.2,0,0.3,0,0.5,0c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0
			c-0.2-0.4-0.4-0.9-0.6-1.3c0,0,0.1,0,0.1,0c0.2,0.1,6.2,5.2,6.2,5.2h0c0.6,0,0.9,0.3,1.6,0.6c0.2,0,0.4,0,0.5,0c0,0,0,0,0,0
			c0,0,0,0,0,0c0,0,0-0.1,0-0.1C45.1,44,45.6,43.3,44.9,42.8z"
        />
        <path
          d="M45.5,40.3L45.5,40.3c0.1,0,0.1,0.1,0.1,0.1c0,0,0-0.1,0-0.1l0,0c0.1-0.2,0.2-0.5,0.2-0.7l0,0c0,0,0-0.1,0-0.1
			c-1.9-0.2-2.8-2.6-4.5-3.5c-0.2,0.4-0.4,0.4-0.9,0.5c0,0,0,0.1,0,0.1l0,0C41.2,38.2,43.8,39.2,45.5,40.3z"
        />
        <path
          d="M39.5,36.3c0.1,0,0.3,0,0.4,0c0.1-0.2,0.2-0.4,0.3-0.6c-0.5-0.6-3.5-4-4-4.3c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1
			c0.1,1.5,0.9,3,1.9,3.4c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2-0.1,0.5-0.1c0,0,0.1,0.1,0.1,0.1c-0.1,0.2-0.2,0.4-0.3,0.6
			C39,35.9,39.3,36.1,39.5,36.3z"
        />
        <path
          d="M35.2,29.2c0.1,0.5,0.3,0.9,0.4,1.4c0,0,0.1,0,0.1,0l0,0c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1l0,0c0-0.1,0-0.1,0.1-0.2
			c-0.1-0.4-0.3-0.9-0.4-1.3c-0.1,0-0.2,0-0.3,0C35.2,29.1,35.2,29.1,35.2,29.2L35.2,29.2z"
        />
        <path
          d="M35.3,28.7C35.3,28.7,35.3,28.7,35.3,28.7c0-0.1,0-0.1,0-0.2c0-0.2-0.1-0.3-0.2-0.4c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1
			c0,0.1,0,0.3,0,0.4c0,0,0.1,0,0.1,0C35.2,28.8,35.2,28.8,35.3,28.7C35.2,28.8,35.3,28.8,35.3,28.7C35.3,28.8,35.3,28.8,35.3,28.7z
			"
        />
        <path
          d="M45.8,40.4c1,0.8,1.7,1.8,3.2,2.1l0,0c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1l0,0c0-0.2,0.1-0.4,0.1-0.6c-0.3-0.2-0.7-0.3-1-0.5
			c-0.2-0.2-0.3-0.4-0.5-0.6c0.3-0.1,0.5-0.1,0.6-0.1c0.4,0,0.6,0.2,1.1,0.5c0.2-0.1,0.4-0.3,0.6-0.4c0-0.1,0.1-0.1,0.1-0.2
			c-0.3-0.2-3.4-1.1-3.8-1.1C46.2,40.1,46.1,40,45.8,40.4z"
        />
        <path
          d="M33.7,51.7c0.1-0.2-0.1-0.2,0.3-0.3c0,0,0,0,0,0c0,0,0.1,0,0.1,0c-0.6-0.9-1.2-1.8-1.7-2.8c-0.1,0-0.3,0-0.4,0
			c-0.1,0.2-0.3,0.3-0.4,0.5c1.1,1.3,2.1,4,3.7,4.7c0.1,0.1,0.1,0.1,0.2,0.2c0,0,0,0,0,0c0,0,0,0,0.1,0.1c0,0,0,0,0-0.1
			c0,0,0,0,0-0.1c0-0.1,0-0.1,0.1-0.2c0.2-0.2,0.3-0.3,0.5-0.5C35.5,52.6,34.7,52,33.7,51.7z"
        />
        <path
          d="M49.5,32c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0,0.3,0,0.4,0h0c0,0,0.1,0,0.1,0c-0.1-0.5,0-0.4-0.6-0.5
			C49.6,31.9,49.5,31.9,49.5,32z"
        />
        <path
          d="M50.6,32.2C50.6,32.2,50.6,32.3,50.6,32.2c0.1,0.1,0.1,0.1,0.1,0.1c0.3,0.3,0.7,0.4,1.1,0.6c0.2,0,0.5,0,0.7,0
			c0,0,0-0.1,0-0.1c-0.4-0.5-0.8-0.6-1.6-0.6C50.9,32.2,50.7,32.2,50.6,32.2z"
        />
        <path
          d="M42.3,20.5c0.3,0.1,0.7,0.2,1,0.2c0.3,0,0.6,0,0.9-0.1c0-0.1,0.1-0.1,0.1-0.2h0l0,0c0,0,0-0.1,0-0.1c-0.5,0-1-0.1-1.5-0.1
			c-0.2,0.1-0.3,0.1-0.5,0.2C42.3,20.5,42.3,20.5,42.3,20.5z"
        />
        <path
          d="M51.4,35.1C51.4,35.1,51.4,35.1,51.4,35.1c0.1,0.4,0.4,0.5,0.9,0.7c0,0,0,0,0,0c0,0,0,0,0.1,0c0-0.2,0-0.3,0-0.5
			C52.1,35.2,51.7,35.1,51.4,35.1C51.4,35,51.4,35,51.4,35.1z"
        />
        <path
          d="M42.4,33.1c0,0.1-0.1,0.1-0.1,0.2c0.6,0.9,6,4,7.3,4c0.1,0,0.2,0,0.2-0.1c0.4,0.3,0.9,0.6,1.3,1l0,0c0,0,0,0,0.1,0.1
			c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0.1-0.2,0.1-0.3,0.2-0.5c-0.5-0.5-3-1.1-3.1-1.2C48,36.1,43.2,33.4,42.4,33.1z"
        />
        <path
          d="M36.3,45.9c-0.1,0.1-0.3,0.2-0.4,0.3c0,0.1-0.1,0.1-0.1,0.2c0.6,0.5,1.8,1.3,2.3,1.9c0,0,0.1,0,0.1,0
			c0-0.1,0.1-0.3,0.1-0.4C37.8,47,37.2,46.4,36.3,45.9z"
        />
        <path
          d="M36.3,47.7C36.3,47.6,36.3,47.6,36.3,47.7c-0.4-0.2-0.9-0.5-1.3-0.7c-0.2-0.1-0.1-0.8-0.5-1.1c-0.1,0-0.1,0.1-0.2,0.1
			c0,0,0,0.1,0.1,0.1l0,0c0.3,0.5,0.5,1,0.8,1.4c0.1,0.1,0.3,0.3,0.4,0.4c0,0,0,0.1,0,0.1c-0.3,0-0.5-0.1-0.8-0.1
			c-0.1-0.7-0.6-1.3-1.2-1.5c-0.1-0.1-0.1-0.1-0.2-0.1c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0.1-0.1,0.1-0.1,0.2
			c1.1,0.9,1.4,2.9,2.7,3.5c0.6,0.6,1.2,1.2,1.9,1.9l0,0c0,0,0,0,0.1,0.1c0,0,0-0.1,0-0.1l0,0c0.1-0.2,0.2-0.4,0.3-0.6
			c0,0,0-0.1,0-0.1c-1-0.7-1.5-1.2-2.2-2.2c0,0,0-0.1,0-0.1c0.1,0,0.1,0,0.2,0c0-0.1,0.1-0.1,0.1-0.2c0.6,0.5,0.9,1.1,1.7,1.4l0,0
			l0,0c0,0,0.1,0,0.1,0c0-0.3,0-0.6,0-0.9C37.2,48.6,36.3,48.3,36.3,47.7z"
        />
        <path
          d="M34.3,49.2c-0.1,0-0.2,0-0.3,0c-0.1,0.1-0.1,0.3-0.2,0.4c0.6,0.7,1.2,1.5,1.8,2.3c0.4,0,0.3,0,0.7-0.1c0,0,0,0,0.1,0
			c0,0,0,0.1,0,0.1c0.1,0.3,0.1,0.7,0.2,1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0,0,0,0.1-0.1c0.1-0.1,0.2-0.2,0.3-0.3l0,0
			c0,0,0.1-0.1,0.1-0.1C36.1,51.6,35.5,50.2,34.3,49.2z"
        />
        <path
          d="M37.3,45.4c0,0,0,0.1,0,0.1c0.2,0.8,0.7,1.4,1.4,1.8c0.2-0.1,0.3-0.2,0.5-0.3c0-0.1,0.1-0.1,0.1-0.2
			C38.6,46.3,37.9,45.8,37.3,45.4C37.2,45.4,37.3,45.4,37.3,45.4z"
        />
        <path
          d="M36.7,45.1c0,0.1,0.1,0.1,0.1,0.2c0,0,0,0,0,0.1c0,0,0,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0
			C37.1,45.2,36.9,45.1,36.7,45.1L36.7,45.1z"
        />
        <path
          d="M39.8,44.2C39.8,44.2,39.8,44.3,39.8,44.2c0,0.1,0,0.1,0,0.1c0.3,0.6,0.6,0.8,1,0.8c0.2,0,0.4,0,0.6-0.1c0,0,0,0,0,0
			c0,0,0.1,0,0.1,0C41.4,44.7,40.7,44.2,39.8,44.2z"
        />
        <path
          d="M42.7,43.7c-0.1,0-0.3,0.1-0.5,0.2c-0.6-0.9-0.8-1.7-2.1-2.5c-0.2,0.5-0.2,0.3-0.5,0.5c0.7,1.1,1.8,2.1,3,2.7
			c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.4-0.1c0.1,0,0.1,0,0.2,0c0,0,0-0.1,0-0.1c-0.1-0.1-0.1-0.3-0.2-0.4
			C43,43.9,42.9,43.7,42.7,43.7z"
        />
        <path
          d="M38.9,45.7C38.9,45.7,38.9,45.7,38.9,45.7L38.9,45.7c0.3,0.3,0.5,0.5,0.6,0.6v0c0,0,0.1,0.1,0.1,0.1c0,0,0.1-0.1,0.1-0.1
			v0c0.1-0.1,0.3-0.3,0.4-0.4l0,0c0,0,0,0,0.1-0.1c-0.2-0.1-0.5-0.3-0.7-0.4C39.3,45.5,39.1,45.6,38.9,45.7z"
        />
        <path
          d="M43.1,39.4c-0.4-0.3-0.9-0.1-1.4-0.3c-1.6-0.7-2.9-3.5-4.6-3.7l0,0c0-0.4-2.5-5.4-2.8-6.9c0,0,0-0.1,0-0.1
			c0-0.8,0.9-3.2,1-3.5c2.4-5.4,4.7-4.2,11-5.5c0.4-0.1,0.8-0.1,1.2-0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0c0.3,0,0.6,0,0.9-0.1
			c0-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1,0-0.1c-0.6-0.1-1.3-0.1-2.1-0.1c-0.3,0-0.6,0-0.8,0c-0.3,0-0.5,0-0.8,0c-0.9,0-1.7,0-2.2-0.1
			c-0.5,0-1,0.1-1.5,0.1c-0.8,0.3-1.6,0.5-2.4,0.8c-0.5,0-1-0.1-1.4-0.1c-0.6,0.6-1.2,1.2-1.8,1.8c-0.1-0.2-0.3-0.4-0.4-0.6
			c-0.9,0.2-1.8,0.9-2.2,1.7c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.2,0.1,0.4,0.2,0.6c-0.4,0.3-0.8,0.7-1.2,1C32,25,32.1,26,32,26.8
			c0.2,0.1,0.4,0.3,0.6,0.4c1-1.1,0.3-2,0.8-3.2c0.6-0.9,1.2-1.8,1.8-2.7c0.2,0,0.3,0.1,0.5,0.1c-0.5,0.9-1,1.7-1.4,2.6
			c-0.3,1.1-0.5,2.3-0.5,3.5c0,3.5,1.3,7,3.2,8.8c0.7,0.8,2.1,2.5,3.4,2.5c0.1,0,0.3,0,0.4-0.1c0.9,1.2,5,4.7,6.3,4.9
			c0.1,0,0.1,0,0.2,0c0.3,0,0.4-0.2,0.6-0.4c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0C47.4,42.5,44,40,43.1,39.4z"
        />
        <path
          d="M44.9,29.3c-0.2,0.2-0.4,0.3-0.6,0.5c0-0.1,0-0.2,0-0.2c0-0.2,0-0.2,0.1-0.5c-0.3-0.1-0.7-0.3-1-0.4
			c0-0.1-0.1-0.2-0.1-0.3c0,0,0-0.1,0-0.1c3,0.2,4.4,1.6,7,1.9c0.2-0.2,0.2-0.1,0.3-0.5c-2-0.7-5.1-2.6-7.2-3c0,0,0,0,0,0
			c0,0,0,0.1,0.1,0.1c0,0.1,0.1,0.1,0.1,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.4,0c-0.1,0-0.3,0-0.4,0c-0.3,0-0.7,0.1-1,0.6
			c2,3.2,7.2,3.6,11.4,4.4c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0-0.3-0.1-0.6-0.1-0.9C50.7,30.4,47.4,30.2,44.9,29.3z"
        />
        <path d="M51.2,22.2c-0.1-0.5-0.2-0.5-0.6-0.7c-0.1,0-0.1,0.1-0.2,0.1c0.1,0.5,0.3,0.5,0.6,0.7C51.1,22.2,51.1,22.2,51.2,22.2z" />
        <path
          d="M58,22c0.2-0.2,0.1-0.1,0.5-0.2c0,0,0-0.1,0-0.1l0,0c0,0,0-0.1,0-0.1c-0.5-0.2-1-0.3-1.5-0.5c0,0,0,0,0,0.1
			c0,0,0,0.1,0,0.1c0.1,0.2,0.1,0.4,0.2,0.6c0,0-0.1,0-0.2,0c-1.2,0-7.5-1.8-9.7-1.9c-0.7,0.3-1.3,0.5-2.1,0.7c0,0,0,0.1,0,0.1
			c0.3,0.3,0.7,0.4,1.2,0.4c0.4,0,0.9-0.1,1.5-0.2c0.5-0.1,1.1-0.2,1.7-0.2c0.4,0,0.8,0,1.3,0.2c0.5,0.1,0.5,0.5,0.8,0.7
			c0.6,0,1.2,0.1,1.7,0.1c1.4,0.6,3.3,1.7,5.2,1.8c0,0,0.1,0,0.1,0c0.2-0.3,0.3-0.6,0.5-0.9l0,0c0,0,0-0.1,0-0.1
			c-0.3-0.1-0.7-0.1-1-0.2C58.2,22.2,58.1,22.1,58,22z"
        />
        <path
          d="M55.4,24C55.4,24,55.5,24.1,55.4,24L55.4,24c0.3,0.3,0.6,0.6,0.8,0.8c0,0,0,0.1,0,0.1C56,25,55.8,25,55.6,25
			c-0.7,0-1.3-0.3-1.9-0.6c-0.6-0.3-1.2-0.6-2-0.6c-0.1,0-0.3,0-0.4,0c-0.1-0.1-0.2-0.3-0.3-0.4c0.3-0.1,0.7-0.2,1.1-0.2
			c0.7,0,1.4,0.2,1.9,0.4c0.1,0,0.1-0.1,0.2-0.1c0-0.1,0.1-0.2,0.1-0.3c-0.7-0.4-1.5-0.8-2.4-0.8c-0.3,0-0.7,0-1.1,0.1
			c-1.8-1.3-5.7-1.5-9.1-1.5c-0.5,0-1,0-1.4,0c-0.9,0.5-2.8,0.7-3.5,1.7c-0.6,1-0.9,1.8-0.9,2.6c0,0.5,0.1,1,0.2,1.6
			c-0.1,0.7-0.2,1.4-0.3,2.2c1.2,4.5,8.1,7.3,11.6,9.9c0.7,0.5,2.1,0.6,2.8,0.9c0,0,0.1,0,0.1,0c0,0,0,0,0,0
			c-0.1-0.4-0.2-0.5-0.2-0.6c0-0.1,0-0.2,0.1-0.5C49,38.4,48,37.5,47,37c-0.4-0.1-0.9-0.1-1.3-0.2c-0.9-0.7-1.1-1.6-2.5-1.8
			c-0.1,0-0.1,0.1-0.2,0.1c0,0,0,0.1,0.1,0.1l0,0c0.1,0.1,0.2,0.2,0.2,0.3c0,0,0,0.1,0,0.1c-0.1,0-0.1,0.1-0.2,0.1
			c-0.4-0.3-0.6-0.4-0.6-0.6c0-0.1,0-0.2,0.1-0.4c-1-0.8-2.1-2.1-3.7-2.4c0.1-0.3,0.1-0.2,0.2-0.3l0,0c0,0,0.1,0,0.1-0.1
			c-1-1.3-1.4-0.9-2.3-2.8c-0.3-0.6-0.4-1.2-0.4-1.8c0-2.3,1.8-4.6,4-5c0.7,0.1,1.4,0.3,2.1,0.4c0.7-0.2,1.4-0.4,2.1-0.6
			c0.6,0.3,1.2,0.6,1.8,0.9c0.9,0.1,1.8,0.1,2.7,0.2c1.1,0.4,2,1.5,3,1.9c0.7,0.3,1.6,0.4,2.5,0.4c1,0,2-0.2,2.7-0.4
			c0.1-0.1,0.1-0.2,0.2-0.3c-0.5-0.3-1-0.7-1.4-1C55.8,23.8,55.7,23.9,55.4,24z"
        />
        <path
          d="M49.2,24.2C49.2,24.2,49.2,24.2,49.2,24.2C49.2,24.2,49.2,24.1,49.2,24.2c-0.3-0.6-1-0.8-1.9-0.8c-0.1,0-0.1,0-0.2,0
			c0,0.1,0,0.2,0,0.3C47.8,23.9,48.5,24,49.2,24.2L49.2,24.2z"
        />
        <path
          d="M58.4,18.7c-0.1,0-0.3,0.1-0.4,0.1c0,0.1-0.1,0.2-0.1,0.3c0,0,0,0.1,0,0.1c0.6,0.4,1.1,0.6,1.7,0.6l0,0c0,0,0.1,0,0.1,0
			c0,0,0,0,0-0.1C59.7,18.7,59.2,18.9,58.4,18.7z"
        />
        <path
          d="M52.5,19.9c-0.1-0.3,0-0.1-0.2-0.3c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.2c0,0,0,0,0.1,0
			C52.4,19.9,52.4,19.9,52.5,19.9C52.5,19.9,52.5,19.9,52.5,19.9z"
        />
        <path
          d="M55,18.6l-2.7-0.5c-0.1,0.1-0.3,0.1-0.4,0.2c0,0,0,0.1,0,0.1c0.5,0.5,1.2,1.1,2.1,1.1c0.2,0,0.4,0,0.6-0.1
			c0.1,0.3,0.3,0.5,0.4,0.8c0.9,0.3,1.9,0.4,2.6,0.5c0.3-0.1,0.6-0.1,0.9-0.2c0.4,0.1,0.5,0.6,1,0.8l0,0c0,0,0.1,0,0.1,0
			c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2,0-0.3c0,0-4.1-1.3-4.2-1.3C55.2,19.2,55.2,18.7,55,18.6z"
        />
        <path
          d="M45.6,23.3c0.1,0,0.2,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c-0.4-0.4-0.9-0.4-1.3-0.5c0,0.1-0.1,0.1-0.1,0.2
			c0,0,0.1,0,0.1,0l0,0C45,23.1,45.3,23.2,45.6,23.3z"
        />
        <path
          d="M54,20.4c0.1,0,0.2,0,0.3,0l0,0c-0.3-0.2-0.7-0.4-1-0.6c0,0.1,0,0.1,0,0.1c0,0.2,0.1,0.2,0.4,0.4
			C53.8,20.3,53.9,20.3,54,20.4z"
        />
        <path
          d="M52.9,30.6C52.9,30.6,52.9,30.6,52.9,30.6c-0.1-0.4-0.1-0.3-0.4-0.5c-0.2,0-0.3-0.1-0.5-0.1c0,0.1-0.1,0.1-0.1,0.2
			c0.2,0.1,0.3,0.3,0.5,0.4C52.5,30.6,52.7,30.6,52.9,30.6C52.8,30.6,52.8,30.6,52.9,30.6z"
        />
        <path
          d="M46.3,31.3c0,0,0.1,0,0.3,0.2c0.1,0,0.1,0,0.2-0.1c0,0,0,0,0.1,0c0,0,0,0,0.1,0c-0.2-0.2-0.1-0.2-0.5-0.3
			C46.3,31.2,46.3,31.3,46.3,31.3z"
        />
        <path
          d="M41.1,25.3c-0.8,0.5-1.7,0.8-2.2,1.6c0,0.9,0.5,2,0.8,2.5c0.5,0.7,10.6,5,11.4,5c0.2,0.2,0.3,0.2,0.5,0.2
			c0.1,0,0.2,0,0.3-0.1c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.1,0,0.2,0l0,0c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1l0,0c0.1-0.3,0.2-0.5,0.3-0.8
			c-0.2-0.2-0.3-0.2-0.4-0.2c-0.1,0-0.1,0-0.2,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.3-0.1c-1.8-0.7-3.5-1.9-5.4-1.9
			c-0.3,0-0.7,0-1,0.1c-1.4-1.5-3.3-2.3-4.6-4.3c0-0.2,0.1-0.4,0.1-0.6c0.5-0.3,1.1-0.5,1.8-0.5c3.2,0,8.2,2.6,10.2,3.3
			c0.1,0,0.2,0,0.3,0c0.1-0.4,0.1-0.8,0.2-1.1c-0.5-0.7-2.4-0.5-3.3-0.7C47.1,27.1,44.8,25.7,41.1,25.3z"
        />
        <path
          d="M42.9,24.9c0-0.1-0.1-0.1-0.1-0.2c-0.2,0-0.5-0.1-0.7-0.1c-0.1,0-0.2,0.1-0.3,0.1c0,0,0,0.1,0,0.1c0.3,0.3,0.5,0.4,1,0.4
			c0,0,0.1-0.1,0.1-0.1C42.9,25.1,42.9,25,42.9,24.9z"
        />
        <path
          d="M44.9,30.9C44.9,30.9,44.9,30.9,44.9,30.9c0,0.1,0,0.1,0,0.1C45,31,45,31,44.9,30.9C45,31,45,31,45.1,30.9
			c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.1,0,0.2-0.1c0,0,0,0,0,0c-0.1,0-0.3-0.1-0.4-0.1C45.1,30.7,45,30.7,44.9,30.9
			C44.9,30.8,44.9,30.8,44.9,30.9z"
        />
        <path
          d="M53.5,28.5c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.1,0.1,0.2,0.1c0,0,0.1-0.1,0.1-0.1l0,0c0.1,0,0.1,0,0.2,0h0c0,0,0-0.1,0-0.1
			C54,28.5,53.7,28.5,53.5,28.5L53.5,28.5z"
        />
        <path
          d="M49.6,25.3c-0.2-0.2-0.3-0.5-0.5-0.7c-0.4,0-0.9,0-1.3,0C46,24.1,43.5,23,41.3,23c-0.5,0.1-1.1,0.3-1.6,0.4
			c-0.9,0.7-1.4,1.9-2.3,2.9c0,0.4,0.2,1,0.2,1.5c0,0.3-0.1,0.5-0.3,0.7c0,0,0,0.1,0.1,0.1c2,3.9,5.3,3.9,9.2,5.8
			c1.5,0.8,3,2.3,5,2.3c0.2,0,0.4,0,0.7-0.1c0-0.1,0.1-0.2,0.1-0.3c-0.1-0.1-3.3-1.5-3.7-1.6c-0.1,0-0.1-0.1-0.2-0.1
			c0.2,0,0.3-0.1,0.5-0.1c0,0,0-0.1,0-0.1c0,0-0.1-0.1-0.1-0.1c0,0-0.1-0.1-0.1-0.1c-1.2-1.1-3.3-0.2-4.6-1.5
			c-0.5-0.6-0.5-0.9-1.4-1.1c0,0-0.7,0.3-1,0.3c0,0,0,0-0.1,0c-0.1-0.1-0.3-0.1-0.4-0.2c0.1-0.2,0.1-0.2,0.1-0.3l0,0
			c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0c-1.8-0.8-2.9-1.9-2.9-3.6c0-0.6,0.1-1.3,0.4-2c0.1,0,0.2-0.1,0.3-0.1
			c0.1,0,0.1,0.1,0.5,0.2c1.2-0.7,1.9-1.4,3.3-1.4c0.2,0,0.4,0,0.6,0c0.5,0.4,1,0.8,1.4,1.1c0.4,0,0.8-0.1,1.2-0.1
			c1.2,0.2,2.4,0.9,3.5,0.9c0.4,0,0.7-0.1,1-0.3c0.1,0,0.3,0.1,0.4,0.1c-0.1,0.2-0.2,0.3-0.3,0.5c0,0,0.1,0,0.1,0l0,0
			c1.3,0.4,2.6,0.9,3.9,1.3c0.2-0.4,0.4-0.7,0.6-1.1l0,0c0,0,0-0.1,0-0.1c-1.3-0.4-2.7-0.8-4-1.1C50.9,25.4,50.2,25.4,49.6,25.3z"
        />
        <path
          d="M51.6,27.3C51.6,27.3,51.6,27.4,51.6,27.3c0,0.1,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0.5,0.2,1.1,0.3,1.6,0.5c0,0,0.1,0,0.1,0
			c0,0,0-0.1,0-0.1l0,0c0,0,0-0.1,0-0.1C52.8,27.6,52.2,27.5,51.6,27.3z"
        />
        <path
          d="M50.8,27.3c0,0,0.1-0.1,0.1-0.1l0,0c0,0,0,0,0.1-0.1c-1.1-0.7-3.4-1.2-5-1.2c0,0-0.1,0-0.1,0l0,0c0,0,0.1,0.1,0.1,0.1
			C47.3,26.8,49.4,27,50.8,27.3z"
        />
        <path
          d="M44.3,25.1c0,0-0.1-0.1-0.1-0.1c-0.2,0-0.5-0.1-0.7-0.1c0,0,0,0.1,0,0.1v0c0,0,0,0.1,0,0.1c0.1,0.1,0.1,0.1,0.2,0.2
			c0.2,0,0.3,0,0.5,0C44.3,25.3,44.3,25.2,44.3,25.1z"
        />
        <path
          d="M7.5,16.7C7.5,16.7,7.5,16.7,7.5,16.7L7.5,16.7c0.6-0.8,2.5-5.1,2.6-5.6c-0.1-0.1-0.3-0.2-0.4-0.3C8.5,12,8,13.3,7.4,15.2
			C7.1,15.4,7,15.6,7,15.7c0,0.3,0.4,0.4,0.4,0.8c0,0,0,0.1,0,0.1C7.4,16.7,7.5,16.7,7.5,16.7z"
        />
        <path
          d="M6.6,24.9c-0.2,0-0.3-0.1-0.5-0.1c0,0,0,0,0,0.1c0,0,0,0,0,0.1c0.1,0.1,0.1,0.3,0.2,0.4c-0.1,0.2-0.3,0.3-0.4,0.5
			c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0h0c0,0,0.1,0,0.1,0c0-0.1,0-0.2,0-0.2c0-0.1,0,0,0.2-0.1c0,0,0,0,0.1,0
			c0,0,0,0,0.1,0c-0.2-0.2-0.2-0.2-0.2-0.4C6.6,25.1,6.6,25.1,6.6,24.9z"
        />
        <path
          d="M9.4,18.4c0.2-0.8,0.4-1.5,0.6-2.3c0.3-0.1,0.5-0.2,0.8-0.3c0.7-0.7,1.3-2.7,1.6-3.5c-0.2-0.2-0.1-0.2-0.5-0.3
			c-1.8,2.4-3.5,5.3-4.8,8.1c-0.5,1.1-0.3,2.5-0.9,3.4c0,0,0,0.1,0,0.1c0.2,0,0.3,0,0.5,0c0.1,0.1,0.1,0.1,0.2,0.2
			c-0.2,0.1-0.5,0.1-0.7,0.2c0,0.1,0,0.3,0,0.4c0.2,0.1,0.4,0.2,0.6,0.4l0,0c0,0,0.1,0,0.1,0.1c0,0,0-0.1,0-0.1l0,0
			c0.3-0.5,0.5-1.1,0.8-1.6c-0.1-0.2-0.1-0.5-0.2-0.7C7.9,21.4,8.9,19.8,9.4,18.4z"
        />
        <path
          d="M16.3,24.6C16.4,24.6,16.4,24.6,16.3,24.6c0.1,0,0.1,0,0.1,0l0,0c0.1-0.3,0.2-0.7,0.3-1c0,0,0,0,0,0c0,0,0-0.1,0-0.1
			c-0.1,0-0.2,0-0.3,0c-0.1,0.3-0.3,0.7-0.4,1C16.2,24.5,16.2,24.5,16.3,24.6L16.3,24.6z"
        />
        <path
          d="M11.2,18c-0.1,0-0.2-0.1-0.3-0.1c-1,2.3-2.1,4.1-2.7,7.1c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0.2,0,0.4-0.1,0.6-0.1
			c0.6-2.2,1.4-4.3,2.5-6.1C11.3,18.5,11.3,18.2,11.2,18z"
        />
        <path
          d="M14.8,25.1c0,0,0.1,0,0.1,0c0.2,0,0.3,0,0.5,0c1.1-4,2.8-7,5.4-9.6c0.1-0.3,0.3-0.5,0.4-0.8c0,0,0.1,0,0.1,0
			c0.1,0,0.2,0,0.2,0.1c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.1,0,0.2-0.1c0.3-0.5,0.7-1,1-1.4c0.9-0.8,2.4-1.2,3.3-1.9c0-0.1,0-0.3,0-0.4
			c-0.1,0-0.3-0.1-0.4-0.1c-3.2,2.1-6.2,3.9-7.9,7.1c-0.4,0.8-1.5,1.5-1.7,2.6c0.1,0.2,0.1,0.4,0.2,0.6c-0.1,0.4-0.8,0.6-1,1
			c-0.1,0.2-0.1,0.4-0.1,0.6c0,0.3,0.1,0.6,0.3,0.7c-1.1,1.4-0.9,2.4-1.7,3.8c0,0.1,0.1,0.1,0.1,0.2c0.1,0,0.2,0.1,0.3,0.1
			c0.3-0.6,0.5-0.9,0.8-1.3C15.1,25.6,15,25.5,14.8,25.1z"
        />
        <path
          d="M11,22.4c0.1-0.1,0.1-0.2,0.1-0.3c0-0.2-0.1-0.3-0.4-0.4c-0.2,0.5-0.2,0.9-0.5,1.4c0,0,0.1,0,0.1,0.1l0,0
			c0.1,0,0.1,0.1,0.2,0.1C10.8,23,10.9,22.8,11,22.4z"
        />
        <path
          d="M13.4,23.4c0-0.1,0-0.3,0-0.4c0,0,0.1,0,0.1-0.1c0.3-0.1,0.6-0.2,0.9-0.4c0.4-0.5,0.2-1.5,0.4-1.9
			c0.3-0.3,0.6-0.5,0.9-0.8c0.4-1,0.9-2.1,1.3-3.1c0.6-0.9,1.6-1.2,1.8-2.4l0,0c0,0,0-0.1,0-0.1c-0.1,0-0.3,0-0.4,0
			c-0.2,0.8-1.5,1.2-2.2,1.8c-1,1-3.4,6.9-3.4,9.6c0,0.1,0,0.2,0,0.3l0,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0l0,0l0,0
			c0.2-0.6,0.4-1.7,0.8-1.9l0,0c0,0,0.1,0,0.1,0C13.9,23.5,13.8,23.5,13.4,23.4z"
        />
        <path
          d="M7.3,16.6C7.3,16.6,7.3,16.6,7.3,16.6l0-0.1c-0.1,0-0.3,0-0.4,0c-0.4,0.6-1.5,2.3-1.6,2.9c0.1,0.5,0.1,1,0.2,1.5
			c-0.2,0.6-1,1.5-1,2.5c0,0.2,0,0.4,0.1,0.6c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0,0,0,0.1-0.1
			C5.7,23.1,7.2,17.7,7.3,16.6L7.3,16.6z"
        />
        <path
          d="M15.6,15.1c0.4-0.7,1.3-0.7,1.7-1.2c0.5-0.6,0.5-1.5,0.9-2.2c0.6-0.8,4.9-4.7,5.7-5.1c0-0.2-0.1-0.3-0.1-0.5
			C23.8,6,23.7,6,23.6,6c-0.7,0.6-1,1.1-1.4,1.8c-0.1,0-0.3,0-0.4,0c0-0.2,0.1-0.5,0.1-0.7c0,0-0.1-0.1-0.1-0.1
			c-0.2,0.1-0.3,0.1-0.5,0.2c-0.6,0.5-0.5,1.4-1,1.9c-0.6,0.4-1.2,0.8-1.8,1.2c-0.8,1.2-1.2,2.3-2.1,3.4c-0.5,0.7-1.7,1-2.3,1.8
			c-0.4,0.6-1,2.2-1,3c0,0.1,0,0.2,0,0.3c-0.4,0.6-1,1.8-1.6,2.2c-0.1-0.2-0.2-0.3-0.3-0.5c-0.1,0.1-0.1,0.1-0.2,0.2
			c0,0.2,0,0.4,0,0.6c0,0,0,0,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0.1-0.1,0.3-0.2,0.4-0.2c0.1,0,0.1,0.1,0.2,0.1
			c-0.2,1.7-0.8,2.1-1.3,3.2c0,0.1,0,0.1,0,0.2c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0c0,0,0,0,0.1-0.1c0.9-0.7,2.3-2.4,2.3-3.5
			c0-0.2,0-0.3-0.1-0.4C14.1,19.2,14.5,16.9,15.6,15.1z"
        />
        <path
          d="M5,24.4c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1
			c0.1-0.1,0.1-0.1,0.1-0.1C5.3,24.5,5.2,24.5,5,24.4C5,24.3,5,24.3,5,24.4z"
        />
        <path
          d="M15.5,4.8L15.5,4.8c0,0,0.1,0,0.1,0l0,0l0,0c0-0.2,0.1-0.4,0.1-0.6c1-0.3,1.7-0.4,2.4-1c0.2-0.2,0.2-0.5,0.3-0.8
			c0.4,0,0.2,0,0.6,0.2C19.5,2,20.1,1,21.1,0.7c0-0.1,0-0.2,0-0.3C21,0.3,20.9,0.1,20.8,0c-0.2,0-0.4,0-0.6,0
			c-0.7,1.2-2.8,2.3-4.1,2.9c0,0.1,0,0.2,0,0.2c0,0.1,0,0.1,0.1,0.3c-0.3,0-0.5,0-0.8,0c0,0.2,0,0.3,0,0.5
			C15.3,4.2,15.4,4.4,15.5,4.8L15.5,4.8z"
        />
        <path
          d="M9.8,9.9c0,0.3,0.1,0.5,0.1,0.8c0,0,0.1,0,0.1,0c0.5-0.3,0.7-0.6,0.9-1.2c0.3-0.2,0.4-0.3,0.4-0.4c0-0.1-0.1-0.2-0.2-0.4
			c1-0.4,3.6-2.3,4-3.1c0-0.1,0.1-0.2,0.1-0.3c0,0,0,0,0-0.1c0,0,0,0,0-0.1c-0.2,0-0.5,0-0.7,0c-0.8,1.3-1.9,1.2-3,2.2
			C10.9,8,10.7,9.2,9.8,9.9z"
        />
        <path
          d="M7.9,9.3c0.1,0,0.1,0,0.2,0c0.2,0.2,0.2,0.2,0.3,0.2c0.1,0,0.2-0.1,0.5-0.1c0.6-1.1,1.2-1.9,1.7-2.7
			C10.5,6.4,10.4,6.1,10,6C9.7,7.2,8.4,8,7.9,9.2C7.9,9.3,7.9,9.3,7.9,9.3z"
        />
        <path
          d="M15,2.4c0-0.1,0.1-0.2,0.1-0.3c0,0,0,0,0,0c0,0,0,0,0-0.1c-0.4,0-0.8-0.1-1.1-0.1c-0.1,0.1-0.2,0.2-0.3,0.3
			c0,0.1,0,0.2,0,0.3C14,2.6,14.2,2.8,14.4,3C14.7,2.8,14.8,2.7,15,2.4z"
        />
        <path
          d="M1.8,18.3c-0.4,1.3-0.8,2.5-1.2,3.8c0.2,0.4,0.4,0.8,0.6,1.2c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0
			c0,0,0,0,0.1,0c-0.2-0.2-0.3-0.4-0.5-0.6c0.8-0.9,1.3-3.1,1.3-4.1C2.3,18.5,2.1,18.4,1.8,18.3z"
        />
        <path
          d="M2.8,18.3c0.3-0.4,0.8-1.2,0.8-2c0-0.2,0-0.4-0.1-0.6c-0.6,0.5-1,0.8-1.4,1c0,0.3,0,0.6,0,0.9c0.6,0.3,0.4,0.3,0.6,0.6
			l0,0C2.6,18.3,2.6,18.3,2.8,18.3C2.7,18.3,2.7,18.3,2.8,18.3L2.8,18.3z"
        />
        <path
          d="M4.5,19c0-0.3-0.1-0.7-0.1-1c0.4-0.9,1.9-2.2,1.9-3.4c0-0.3-0.1-0.5-0.3-0.8c0.7-0.6,1.8-2.5,1.8-3.6c0-0.2,0-0.3-0.1-0.4
			c-1.2,1.6-5.1,10.4-5.1,13.7c0,0.5,0.1,0.9,0.3,1.1c0.1,0,0.1,0,0.2-0.1l0,0c0,0,0.1,0,0.1,0c-0.1-0.2-0.2-0.5-0.3-0.7
			C4,22.4,4.2,20.8,4.5,19z"
        />
        <path
          d="M7.6,7c0.5-0.4,1-0.8,1.4-1.1c0,0,0.1-0.1,0.1-0.1c0-0.1,0-0.2,0-0.3c-0.1,0-0.1,0-0.2,0C8.4,5.6,8,5.7,7.5,5.8
			C6.8,6.9,6.1,8,5.4,9.1c0.1,0.2,0.3,0.5,0.4,0.7C6.7,9.5,7,7.7,7.6,7z"
        />
        <path d="M0,20.3L0,20.3c0.1-0.1,0.2-0.2,0.2-0.2c0.1-0.1,0.2-0.3,0.2-0.4c0-0.1,0-0.2,0-0.3C0.3,19.7,0.1,20,0,20.3z" />
        <path
          d="M34.8,54.7C34.8,54.7,34.8,54.7,34.8,54.7c0,0.1,0,0.1,0,0.1c0.1,0.2,0.1,0.3,0.1,0.4c0,0.1-0.1,0.1-0.2,0.2
			c0,0.1,0.1,0.2,0.1,0.3c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0-0.1c0,0,0-0.1,0-0.1c0.1-0.2,0.2-0.5,0.3-0.7
			C35.1,54.8,35.2,54.8,34.8,54.7z"
        />
        <path
          d="M30,56.6c0.1,0.1,0.1,0.2,0.2,0.2c0.2,0.3,0.4,0.5,0.6,0.8c0,0,0,0,0,0.1c0,0.1,0,0.1,0,0.2v0l0,0c0-0.1,0.1-0.2,0.1-0.3
			c0-0.1,0.1-0.3,0.1-0.4C30.6,56.9,30.3,56.7,30,56.6L30,56.6z"
        />
        <path
          d="M16.4,26.9c-0.1,0.2-0.2,0.3-0.2,0.5c0,0.1,0,0.2,0,0.4c0.2,0.1,0.5,0.3,0.7,0.4l0,0h0c0,0,0.1,0,0.1,0
			c-0.1-0.3-0.1-0.6-0.2-0.9C16.7,27,16.7,27,16.4,26.9z"
        />
        <path
          d="M28.6,54.7c0-0.5-0.7-1.7-1-2.1c-0.2,0-0.3-0.1-0.5-0.1c-0.1,0.1-0.1,0.3-0.2,0.4c0,0.1,0,0.1,0,0.2c0,0.6,0.7,1.3,1,1.7
			C28.1,54.7,28.4,54.7,28.6,54.7L28.6,54.7z"
        />
        <path
          d="M25.5,54.2c0,0,0,0.1,0,0.1c0.4,0.1,0.8,0.3,1.3,0.4c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0.1,0c-0.3-0.3-0.5-0.7-0.8-1
			C25.9,53.9,25.7,53.8,25.5,54.2z"
        />
        <path
          d="M34.8,54.4C34.8,54.4,34.9,54.4,34.8,54.4c-0.4-0.6-3.5-4.3-3.5-4.3c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.1-0.1,0.1-0.1,0.2
			c0,0.9,2.3,3.2,2.9,4.1c0.2,0,0.5,0,0.7,0C34.6,54.5,34.6,54.5,34.8,54.4C34.8,54.4,34.8,54.4,34.8,54.4z"
        />
        <path
          d="M26,42.4c-0.1-0.6-0.2-1.1-0.6-1.4c-0.2,0.2-0.4,0.5-0.4,0.8c0,0.1,0,0.3,0.1,0.4c0.2,0.2,0.5,0.2,0.8,0.3
			C25.9,42.4,25.9,42.4,26,42.4z"
        />
        <path
          d="M31.3,53.4C31.3,53.4,31.3,53.4,31.3,53.4c0,0.1,0,0.1,0,0.2c0.3,1.3,0.7,1.7,1.6,2.8c0.3-0.1,0.5-0.1,0.8-0.2
			c0-0.3-0.1-0.5-0.1-0.8C32.9,54.8,31.6,53.5,31.3,53.4z"
        />
        <path
          d="M30.2,52.5c-0.1,0-0.2,0.1-0.3,0.1c0,0,0,0,0.1,0.1l0,0c0.2,0.2,0.4,0.5,0.5,0.7c0.3,0,0.5-0.1,0.8-0.1c0-0.1,0-0.3,0-0.4
			C30.9,52.8,30.5,52.7,30.2,52.5z"
        />
        <path
          d="M27.6,51.7c1.1,2.3,2.8,2.9,3.7,5.3c0.3,0,0.6,0,0.9,0c0,0.2-0.1,0.4-0.1,0.5c0,0.1,0,0.2,0.2,0.3c0.1,0,0.2,0.1,0.3,0.1
			c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0-0.1,0-0.1,0-0.2c0.1-0.2,0.1-0.3,0.2-0.5c-1.7-2.1-3-4-4.7-6.3C28,51.3,27.8,51.5,27.6,51.7z"
        />
        <path
          d="M29.5,55.1c-0.3-0.1-0.6-0.1-0.9-0.2c-0.1,0.2-0.1,0.4-0.1,0.6c0,0.4,0.3,0.7,0.8,1c0.2-0.1,0.3-0.1,0.5-0.2l0,0
			c0,0,0.1,0,0.1,0C29.8,55.9,29.7,55.5,29.5,55.1z"
        />
        <path
          d="M19.7,26.1c-0.2,0.3-0.4,0.5-0.6,0.8c-0.1,0-0.1,0.1-0.2,0.1c0.2-1.2,1.6-3.1,1.6-4.1c0-0.2,0-0.3-0.1-0.4
			c0.8-0.7,1.2-1.8,1.8-2.8l0,0c0,0,0-0.1,0-0.1c-0.1,0-0.2-0.1-0.3-0.1c-2.3,1.7-2.9,5.7-4,8.8c0,0.1,0,0.3,0,0.4
			c0.3,0.1,0.5,0.1,0.8,0.2l0,0c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1l0,0c0-0.4,0.1-0.9,0.1-1.3c0.1-0.2,0.1-0.2,0.2-0.2
			c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.2,0c0.2-0.3,0.3-0.5,0.5-0.8C20,26.3,19.8,26.2,19.7,26.1z"
        />
        <path
          d="M20.6,30.2c0-0.1,0-0.1,0.1-0.2c0.5-1.4,0.3-3.1,0.5-4.2c0.4-2.1,1.2-5,2.1-6.5c0.5-0.4,1-0.8,1.5-1.1
			c0.6-0.8,0.9-1.8,1.6-2.5c1.1-1,3.7-1.2,4.3-2.7l0,0c0,0,0-0.1,0-0.1c-0.1,0-0.3-0.1-0.4-0.1c-3.7,1.9-4.9,3.1-7.3,6.4
			c-0.4,0.6-0.9,1.2-1.3,1.7c-0.1,0.2-0.1,0.4-0.1,0.7c0,0.4,0,0.7,0,1.1c0,0.3,0,0.6-0.2,0.8c-0.2,0.4-0.8,0.3-0.9,0.9
			c-0.1,0.4-0.1,0.8-0.1,1.1c0,0.4,0,0.7,0,1c0,0.4,0,0.7-0.2,1c0.1,0.1,0.3,0.3,0.4,0.4c-0.1,0-0.3,0-0.4,0
			c-0.2,0.2-0.3,0.4-0.5,0.6c0.3,0.4,0.6,0.8,0.8,1.3C20.6,30.1,20.6,30.2,20.6,30.2C20.6,30.2,20.6,30.3,20.6,30.2
			C20.6,30.3,20.6,30.2,20.6,30.2z"
        />
        <path d="M17.4,24.2c-0.4,0.6-0.8,1-0.8,1.9c0.2,0,0.3,0.1,0.5,0.1c0.2-0.3,0.6-0.9,0.6-1.4C17.8,24.6,17.7,24.4,17.4,24.2z" />
        <path d="M20.6,30.9L20.6,30.9c0,0.1,0,0.2,0,0.3h0c0,0,0.1,0,0.1,0C20.7,31.1,20.7,31,20.6,30.9z" />
        <path
          d="M25,35.7C25,35.7,25,35.7,25,35.7C25,35.7,25,35.7,25,35.7c0,0,0-0.1,0-0.2c0-0.3,0-0.9,0-1.4c0-0.6,0-1.2-0.2-1.4
			c-0.3-0.3-0.3-0.8-0.3-1.3c0-1.2,0.4-2.7,0.8-3.5c0-0.8,0-1.5,0-2.3c0.3-0.5,1.3-1.8,1.3-2.6c0-0.2,0-0.3-0.2-0.4
			c-1,0.9-2.6,5.9-2.6,7.8c0,0.2,0,0.4,0.1,0.5c-0.1,0.2-0.2,0.3-0.3,0.5c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.2-0.1-0.3-0.2
			c-0.1,0.1-0.2,0.3-0.3,0.4c0.1,0.6,0.3,1.1,0.3,1.5c0,0.1,0,0.3-0.1,0.4c0.2,0.2,0.4,0.2,0.5,0.2c0.1,0,0.2,0,0.4-0.1
			c0.4,0.6,0.7,1.5,1,2.2C25,35.6,25,35.6,25,35.7z"
        />
        <path
          d="M20.9,32c-0.1,0.1-0.1,0.3-0.2,0.4c0.1,0.2,0.3,0.4,0.4,0.5c0,0,0.1,0.1,0.1,0.1l0,0c0-0.1,0-0.1,0-0.2l0,0
			c0.1-0.1,0.1-0.2,0.1-0.3C21.3,32.4,21.2,32.2,20.9,32z"
        />
        <path
          d="M25.2,40.6L25.2,40.6c0.1,0,0.1,0,0.1,0c0,0,0-0.1,0-0.1l0,0c0-0.2,0-0.5,0-0.7c0-0.7-0.2-1.2-0.5-1.7
			c0.2-0.1,0.3-0.3,0.5-0.4c-0.1-0.7-0.2-1.5-0.5-1.9c0,1.3-0.5,2.1-0.5,3.1c0,0.3,0,0.6,0.1,1c0.1,0.2,0.3,0.4,0.4,0.6
			C25.1,40.6,25.2,40.6,25.2,40.6z"
        />
        <path
          d="M22.4,30c-0.3,0.4-0.6,0.8-0.9,1.1c0.1,0.7,0.3,1.4,0.4,2.2c0.2,0,0.4,0,0.6,0c0,0,0,0,0,0c0,0,0.1,0,0.1,0
			c-0.2-0.5-0.2-1.1-0.2-1.6c0-0.5,0.1-1.1,0.2-1.4C22.5,30.1,22.4,30,22.4,30z"
        />
        <path
          d="M21.5,29.8c-0.1-0.1-0.3-0.1-0.4-0.2c0,0.1-0.1,0.1-0.1,0.2c0,0,0.1,0,0.1,0l0,0c0.1,0,0.1,0,0.2,0.1c0,0,0,0,0.1,0
			C21.4,29.8,21.5,29.8,21.5,29.8C21.5,29.8,21.5,29.8,21.5,29.8z"
        />
      </g>
      <g id="text_1_">
        <g>
          <path
            d="M68.7,11.3H74c1.8,0,2.6,0.1,3.3,0.5c1.6,0.7,2.7,2.3,2.7,4.5c0,2-1,3.8-2.8,4.5v0c0,0,0.2,0.2,0.6,0.8l3.4,6.1h-3.3
				l-3.3-6.1h-2.9v6.1h-3V11.3z M74.4,19c1.6,0,2.6-0.9,2.6-2.6c0-1.6-0.7-2.5-3-2.5h-2.3V19H74.4z"
          />
          <path d="M83.9,11.3h9.8v2.6h-6.8v4.3h5.5v2.6h-5.5v4.4h7.2v2.6H83.9V11.3z" />
          <path
            d="M97.2,11.3h6.3c3.1,0,5.2,2.2,5.2,5.3c0,3.2-2.2,5.4-5.2,5.4h-3.4v5.7h-3V11.3z M103,19.5c1.7,0,2.8-1.1,2.8-2.8
				c0-1.7-1-2.8-2.7-2.8h-2.8v5.6H103z"
          />
          <path
            d="M118.8,11.1c4.8,0,8.5,3.7,8.5,8.4c0,4.8-3.7,8.6-8.5,8.6c-4.8,0-8.5-3.8-8.5-8.6C110.3,14.7,114,11.1,118.8,11.1z
				 M118.8,25.3c3,0,5.4-2.5,5.4-5.9c0-3.2-2.4-5.6-5.4-5.6c-3,0-5.4,2.4-5.4,5.6C113.4,22.8,115.8,25.3,118.8,25.3z M119.3,7.1h3
				l-2.4,3.1h-2.4L119.3,7.1z"
          />
          <path
            d="M130.3,11.3h5.3c1.8,0,2.6,0.1,3.3,0.5c1.6,0.7,2.7,2.3,2.7,4.5c0,2-1,3.8-2.8,4.5v0c0,0,0.2,0.2,0.6,0.8l3.4,6.1h-3.3
				l-3.3-6.1h-2.9v6.1h-3V11.3z M136,19c1.6,0,2.6-0.9,2.6-2.6c0-1.6-0.7-2.5-3-2.5h-2.3V19H136z"
          />
          <path d="M148.9,13.9h-5.4v-2.6h13.8v2.6h-5.4v13.9h-3V13.9z" />
          <path d="M159.5,11.3h9.8v2.6h-6.8v4.3h5.5v2.6h-5.5v4.4h7.2v2.6h-10.2V11.3z" />
          <path
            d="M172.8,11.3h5.3c1.8,0,2.6,0.1,3.3,0.5c1.6,0.7,2.7,2.3,2.7,4.5c0,2-1,3.8-2.8,4.5v0c0,0,0.2,0.2,0.6,0.8l3.4,6.1h-3.3
				l-3.3-6.1h-2.9v6.1h-3V11.3z M178.4,19c1.6,0,2.6-0.9,2.6-2.6c0-1.6-0.7-2.5-3-2.5h-2.3V19H178.4z"
          />
        </g>
        <g>
          <path
            d="M68.7,34.3h5.9c3,0,5.1,1.5,5.1,4.2c0,1.5-0.7,2.8-2,3.5v0c1.8,0.5,2.7,2.2,2.7,3.9c0,3.3-2.6,4.8-5.7,4.8h-5.9V34.3z
				 M74.6,41c1.3,0,2-0.9,2-2.1s-0.7-2-2.1-2h-2.8V41H74.6z M74.9,48.1c1.5,0,2.4-1,2.4-2.4c0-1.4-0.9-2.4-2.4-2.4h-3.2v4.7H74.9z"
          />
          <path
            d="M83.6,34.3h5.3c1.8,0,2.6,0.1,3.3,0.5c1.6,0.7,2.7,2.3,2.7,4.5c0,2-1,3.8-2.8,4.5v0c0,0,0.2,0.2,0.6,0.8l3.4,6.1h-3.3
				l-3.3-6.1h-2.9v6.1h-3V34.3z M89.2,42c1.6,0,2.6-0.9,2.6-2.6c0-1.6-0.7-2.5-3-2.5h-2.3V42H89.2z"
          />
          <path
            d="M106.9,46.5h-5.8l-1.4,4.2h-3.1l5.8-16.4h3.1l5.8,16.4h-3.1L106.9,46.5z M104.1,37.1c0,0-0.4,1.6-0.7,2.5l-1.5,4.4h4.3
				l-1.5-4.4C104.4,38.7,104.1,37.1,104.1,37.1L104.1,37.1z"
          />
          <path
            d="M113.9,46.5c0,0,1.8,1.7,4.1,1.7c1.2,0,2.4-0.6,2.4-2c0-2.9-7.7-2.4-7.7-7.5c0-2.7,2.4-4.8,5.5-4.8
				c3.2,0,4.9,1.8,4.9,1.8l-1.3,2.4c0,0-1.6-1.4-3.6-1.4c-1.4,0-2.5,0.8-2.5,2c0,2.9,7.7,2.2,7.7,7.4c0,2.6-2,4.8-5.4,4.8
				c-3.7,0-5.7-2.2-5.7-2.2L113.9,46.5z"
          />
          <path d="M126.3,34.3h3v16.4h-3V34.3z" />
          <path d="M133.5,34.3h3v13.9h7.1v2.6h-10.1V34.3z" />
        </g>
      </g>
    </svg>
  )
}

export default Map
